import * as React from 'react'
import { NavMain } from '@/layouts/dashboard/nav-main'
import { NavUser } from '@/layouts/dashboard/nav-user'
import { TeamSwitcher } from '@/layouts/dashboard/team-switcher'
import { useAuthContext } from '@/contexts/auth-context/auth-provider'
import { getAvailableMenus } from '@/contexts/auth-context/permissions'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
  useSidebar,
} from '@/components/ui/sidebar'

type Prop = React.ComponentProps<typeof Sidebar> & {
  onSidebarOpen: (value: boolean) => void
}

export function AppSidebar({ onSidebarOpen, ...props }: Prop) {
  const { user } = useAuthContext()
  const { open } = useSidebar()

  // ข้อมูลบริษัท/ระบบ
  const teams = [
    {
      name: 'RFC Back Office',
      logo: () => <img src="/assets/images/rfc-logo.png" alt="logo" />,
      plan: 'Management System',
    },
  ]

  // ดึงเมนูตาม role ของผู้ใช้ แบ่งเป็นกลุ่ม
  const availableMenuGroups = getAvailableMenus(user)

  React.useEffect(() => {
    onSidebarOpen(open)
  }, [open])

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <TeamSwitcher teams={teams} />
      </SidebarHeader>
      <SidebarContent>
        <NavMain groups={availableMenuGroups} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
